import {
  CLEAR_FINPLAYER_DATA,
  SET_FINPLAYER_DATA_ERROR,
  SET_FINPLAYER_DATA_INIT,
  SET_FINPLAYER_DATA_SUCCESS,
} from 'containers/Player/actions/fin-player/constants';
import { SET_SHOW_FINPLAYER } from '../actions/fin-player/constants';

const initialState = {
  isShown: false,
  content: null,
  loading: false,
  error: null,
};

const FinPlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FINPLAYER_DATA_INIT:
      return { ...initialState, loading: true, error: null };
    case SET_FINPLAYER_DATA_SUCCESS:
      return { isShown: false, content: action.content, loading: false, error: null };
    case SET_FINPLAYER_DATA_ERROR:
      return { ...initialState, error: true };
    case CLEAR_FINPLAYER_DATA:
      return { ...initialState, error: null};
    case SET_SHOW_FINPLAYER:
      return {...state, isShown: action.payload}
    default:
      return state;
  }
};

export default FinPlayerReducer;
